module.exports = __webpack_public_path__ + "media/components/page-footer/static/mountain-forecast__logo--white-e493be58ac5d4854c4a9cc45d510f7e6.png";